var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c8db84fcbab746bdd065603dfdd9e9315f97e49b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webapp-tweet-hunter@pony-express-studio"]={id:"c8db84fcbab746bdd065603dfdd9e9315f97e49b"};
      